<app-scroll-view class="tabs-container" [vertical]="false" [horizontal]="true">
  <div
    *ngFor="let item of items; let i = index"
    class="tab-item"
    [ngClass]="{ disabled: item.disabled, selected: i === selectedTabIndex }"
    (click)="onTabItemClick($event, i, item)"
    [title]="item.text"
  >
    <div class="tab-item-content">
      {{ item.text }}
    </div>
  </div>
</app-scroll-view>
